<div class="input-cell">
    <nb-actions>
        <nb-action>
            <nb-icon [icon]="collapsed ? 'arrowhead-left-outline' : 'arrowhead-right-outline'"
                pack="eva" pack="eva" (click)="toggleContainer()">
            </nb-icon>
        </nb-action>
        <nb-action>
            Templates
        </nb-action>
    </nb-actions>
</div>
<div class="input-cell">
    <div class="description">Content Aligned vertically top</div>
    <div class="graphic cell-3" (click)="createGrid(1)">
        <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
            <!-- Define diagonal stripe pattern -->
            <defs>
                <pattern id="diagonalStripes" patternUnits="userSpaceOnUse" width="8" height="8">
                <path d="M-2,2 L2,-2 M0,8 L8,0 M6,10 L10,6" stroke="white" stroke-width="1" />
                </pattern>
            </defs>
            <!-- Outer Rectangle -->
            <rect class="grid-option-rec" x="0" y="0" width="140" height="60" stroke="white" fill="none" stroke-width="1" />
            
            <!-- Inner Rectangle -->
            <rect class="grid-option-rec" x="2" y="2" width="134" height="20" stroke="white" fill="url(#diagonalStripes)" stroke-width="1" />
          </svg>
          
    </div>
</div>
<div class="input-cell">
    <div class="description">Content Aligned vertically middle</div>
    <div class="graphic cell-3" (click)="createGrid(2)">
        <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
            <!-- Define diagonal stripe pattern -->
            <defs>
                <pattern id="diagonalStripes" patternUnits="userSpaceOnUse" width="8" height="8">
                <path d="M-2,2 L2,-2 M0,8 L8,0 M6,10 L10,6" stroke="white" stroke-width="1" />
                </pattern>
            </defs>
            <!-- Outer Rectangle -->
            <rect class="grid-option-rec" x="0" y="0" width="140" height="60" stroke="white" fill="none" stroke-width="1" />
            
            <!-- Inner Rectangle (Centered) -->
            <rect class="grid-option-rec" 
              x="3" 
              y="20" 
              width="134" 
              height="20" 
              stroke="white" 
              fill="url(#diagonalStripes)" 
              stroke-width="1" />
          </svg>
          
    </div>
</div>
<div class="input-cell">
    <div class="description">Content Aligned vertically bottom</div>
    <div class="graphic cell-4" (click)="createGrid(3)">
        <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
            <!-- Define diagonal stripe pattern -->
            <defs>
                <pattern id="diagonalStripes" patternUnits="userSpaceOnUse" width="8" height="8">
                <path d="M-2,2 L2,-2 M0,8 L8,0 M6,10 L10,6" stroke="white" stroke-width="1" />
                </pattern>
            </defs>
            <!-- Outer Rectangle -->
            <rect class="grid-option-rec" x="0" y="0" width="140" height="60" stroke="white" fill="none" stroke-width="1" />
            
            <!-- Inner Rectangle (Bottom Positioned) -->
            <rect class="grid-option-rec" 
              x="3" 
              y="38" 
              width="134" 
              height="20" 
              stroke="white" 
              fill="url(#diagonalStripes)" 
              stroke-width="1" />
          </svg>
          
         
    </div>
</div>
<div class="input-cell">
    <div class="description">Content Aligned horizontally left</div>
    <div class="graphic cell-5" (click)="createGrid(4)">
        <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
            <!-- Define diagonal stripe pattern -->
            <defs>
                <pattern id="diagonalStripes" patternUnits="userSpaceOnUse" width="8" height="8">
                <path d="M-2,2 L2,-2 M0,8 L8,0 M6,10 L10,6" stroke="white" stroke-width="1" />
                </pattern>
            </defs>
            <!-- Outer Rectangle -->
            <rect class="grid-option-rec" x="0" y="0" width="140" height="60" stroke="white" fill="none" stroke-width="1" />
            
            <!-- Inner Rectangle (Left) -->
            <rect class="grid-option-rec" 
              x="0" 
              y="2" 
              width="46.67" 
              height="56" 
              stroke="white" 
              fill="url(#diagonalStripes)" 
              stroke-width="1" />
          </svg>
          
          
    </div>
</div>
<div class="input-cell">
    <div class="description">Content Aligned horizontally center</div>
    <div class="graphic cell-5" (click)="createGrid(5)">
        <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
            <!-- Define diagonal stripe pattern -->
            <defs>
                <pattern id="diagonalStripes" patternUnits="userSpaceOnUse" width="8" height="8">
                <path d="M-2,2 L2,-2 M0,8 L8,0 M6,10 L10,6" stroke="white" stroke-width="1" />
                </pattern>
            </defs>
            <!-- Outer Rectangle -->
            <rect class="grid-option-rec" x="0" y="0" width="140" height="60" stroke="white" fill="none" stroke-width="1" />
            
            <!-- Inner Rectangle (Center) -->
            <rect class="grid-option-rec" 
            x="46.67" 
            y="2" 
            width="46.67" 
            height="56" 
            stroke="white" 
            fill="url(#diagonalStripes)" 
            stroke-width="1" />
        </svg>
    </div>  
      
</div>
<div class="input-cell">
    <div class="description">Content Aligned horizontally right</div>
    <div class="graphic cell-5" (click)="createGrid(6)">
        <svg width="140px" height="60px" xmlns="http://www.w3.org/2000/svg">
            <!-- Define diagonal stripe pattern -->
            <defs>
                <pattern id="diagonalStripes" patternUnits="userSpaceOnUse" width="8" height="8">
                <path d="M-2,2 L2,-2 M0,8 L8,0 M6,10 L10,6" stroke="white" stroke-width="1" />
                </pattern>
            </defs>
            <!-- Outer Rectangle -->
            <rect class="grid-option-rec" x="0" y="0" width="140" height="60" stroke="white" fill="none" stroke-width="1" />
            
            <!-- Inner Rectangle (Right) -->
            <rect class="grid-option-rec" 
            x="93.33" 
            y="2" 
            width="46.67" 
            height="56" 
            stroke="white" 
            fill="url(#diagonalStripes)" 
            stroke-width="1" />
        </svg>
    </div>  
      
</div>
